import { animate, state, style, transition, trigger } from '@angular/animations';


export const openFullscreen = trigger('openClose', [
  state('open', style({
    height: '100vh',
    margin: 'unset',
    borderRadius: 'unset',
    padding: 'unset'
  })),
  state('closed', style({
  })),
  transition('open => closed', [
    animate('1s')
  ]),
  transition('closed => open', [
    animate('0.5s')
  ]),
]);

export const hideByHeight = trigger('hideHeigth', [
  state('open', style({
  })),
  state('hide', style({
    height: 0,
    padding: 0,
    overflow: 'hidden'
  })),
  transition('open => hide', [
    animate('0.2s')
  ]),
  transition('hide => open', [
    animate('0.2s')
  ]),
]);

